import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';

import { PROFILE_FIELDS_TYPES } from '../../../../../constants/formFields';
import TextInput from '../../../../TextInput';
import ErrorBlock from '../../../../common/ErrorBlock';
import SelectCustom from '../../../../SelectCustom';
import {
  FIELD_FILLING_TYPES,
  getFieldProps,
} from '../../../../../utils/fields/getFieldProps';

const {
  LOCATION,
  REASON_TYPE,
  REASON_NOTE,
  REASON_TYPE_ID,
  REASON_COMMENT,
} = PROFILE_FIELDS_TYPES;

export const ChangeStatusForm = ({
  formatMessage,
  errors,
  onChange,
  locationsList,
  reasonList,
  locationId,
  reasonTypeId,
  note,
}) => {
  const makeField = getFieldProps(formatMessage, onChange);
  const error = get(errors, 'description') || { id: 'common.error' };
  return (
    <Fragment>
      <SelectCustom
        {...makeField(LOCATION, FIELD_FILLING_TYPES.REQUIRED)}
        options={locationsList}
        value={locationId}
        needUpdateDefaultValue
      />
      <SelectCustom
        {...makeField(REASON_TYPE, FIELD_FILLING_TYPES.REQUIRED)}
        options={reasonList}
        value={reasonTypeId}
        needUpdateDefaultValue
        name={REASON_TYPE_ID}
        onChange={({ value }) => onChange({ [REASON_TYPE_ID]: value })}
      />
      <TextInput
        {...makeField(REASON_NOTE, FIELD_FILLING_TYPES.OPTIONAL)}
        value={note}
        name={REASON_COMMENT}
        onChange={value => onChange({ [REASON_COMMENT]: value })}
      />
      <If condition={Boolean(errors)}>
        <ErrorBlock errors={error} className="mt3" />
      </If>
    </Fragment>
  );
};

ChangeStatusForm.propTypes = {
  errors: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({ description: PropTypes.string }),
  ]),
  formatMessage: PropTypes.func,
  onChange: PropTypes.func,
  locationId: PropTypes.number,
  reasonTypeId: PropTypes.number,
  note: PropTypes.string,
  locationsList: PropTypes.array,
  reasonList: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardTable/ChangeStatus/ChangeStatusForm/index.jsx